import { Box, styled } from '@mui/system';

export const AppLayout = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh'
});
